import styled from "styled-components";
// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";
// @ts-ignore
import { fontBold } from "@fdr/static-ui/Typography";

export const Container = styled.div`
  background-color: ${buildColor("grey", "L4")};
`;

export const Content = styled.div`
  margin-top: 8px;
  border-top: 1px solid ${buildColor("grey", "L2")};
  border-bottom: 1px solid ${buildColor("grey", "L2")};
  background-color: ${buildColor("white")};
  padding: 10px 16px;
  margin-bottom: 42px;
`;

export const Title = styled.h1`
  height: 20px;
  color: ${buildColor("grey", "D4")};
  font-size: 16px;
  font-family: ${fontBold};
  line-height: 125%;
  margin-bottom: 10px;
`;
